// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Vm-z","badgeLink":"Wm-z","category":"Xm-z"};